export const getFlag = (code, flags = [], key = 'code') => {
    const findFlag = (flag) => {
        if (!flag) {
            return false;
        }

        if (Array.isArray(code)) {
            return code.some((c) => c.toLowerCase() === flag[key]?.toLowerCase());
        }

        return flag[key]?.toLowerCase() === code?.toLowerCase();
    };

    if (!Array.isArray(flags)) {
        return false;
    }

    return flags.find(findFlag) || false;
};
